var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClubs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "5.75 1.75 20.5 28.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.97 1.75H7.03c-.7 0-1.28.58-1.28 1.28v25.94c0 .7.58 1.28 1.28 1.28h17.94c.7 0 1.28-.58 1.28-1.28V3.03c0-.7-.58-1.28-1.28-1.28zM20 20.6c-.8 0-1.72-.28-2.5-.77l.67 3.76c.02.03.03.08.03.12 0 .14-.11.25-.25.25h-3.89c-.07 0-.14-.04-.19-.09a.227.227 0 0 1-.05-.21l.71-3.85c-.79.5-1.71.79-2.53.79-1.83 0-3.31-1.48-3.31-3.31s1.48-3.31 3.31-3.31c.46 0 .95.09 1.45.26-.46-.96-.76-2.07-.76-2.89 0-1.82 1.48-3.31 3.31-3.31s3.31 1.49 3.31 3.31c0 .82-.3 1.93-.76 2.89.5-.17.99-.26 1.45-.26 1.83 0 3.31 1.48 3.31 3.31S21.83 20.6 20 20.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClubs);
export default __webpack_public_path__ + "static/media/clubs.9ee28dce993788d1c5fe75d8692cb100.svg";
export { ForwardRef as ReactComponent };